import React from 'react';

const PrimaryButton = ({ children, className, type = 'button', ...props }) => {
    return (
        <button
            className={`btn bg-blue-600 hover:bg-blue-600 text-white border-0 px-4 py-1.5 font-medium ${className}`}
            type={type}
            {...props}
        >
            {children}
        </button>
    );
};

export default PrimaryButton;
